import React from "react";
import { cn, withVersion } from "../../lib/utils";
import { useTheme } from "../../theme/ThemeContext";

const DARK = withVersion("https://media.sec4us.com.br/logo/secface-dark.png");   // white "SEC" — for dark backgrounds
const LIGHT = withVersion("https://media.sec4us.com.br/logo/secface-light.png"); // dark "SEC" — for light backgrounds

/**
 * SecFace wordmark (raster). Picks the light/dark asset from the active theme;
 * pass `forceDark` on surfaces that are always dark (404, dark heroes).
 */
export function Logo({ className, forceDark = false }) {
  const { theme } = useTheme();
  const src = forceDark || theme === "dark" ? DARK : LIGHT;
  return (
    <img
      src={src}
      alt="SecFace"
      className={cn("h-7 w-auto select-none", className)}
      draggable={false}
    />
  );
}
